class WarrantyForm {
  constructor(formId, toastId) {
    this.form = document.getElementById(formId);
    this.toast = document.getElementById(toastId);
    this.apiUrl = "/apps/chicco-form/warranty";
    this.apiKey = "e7bb9eb9cf0bf42523c8cc713ca1bfae";

    if (this.form) {
      this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    }
  }

  async handleSubmit(e) {
    e.preventDefault();

    this.clearErrors();
    this.hideToast();

    const submitBtn = this.form.querySelector("button[type='submit']");
    submitBtn.classList.add("loading");

    const formData = new FormData(this.form);

    let isValid = true;
    const requiredFields = [
      "customerName",
      "serialNumber",
      "purchaseDate",
      "retailerName",
      "proofOfPurchase",
      "customerEmail",
      "customerPhone",
      "customerAddress"
    ];

    requiredFields.forEach((field) => {
      const input = this.form.querySelector(`[name="${field}"]`);
      const labelForError = this.form.querySelector(`label[for="${field}"]`)?.textContent;

      if (input && !input.value.trim()) {
        this.showFieldError(field, `${labelForError || field} is required`);
        isValid = false;
      }
    });

    if (!isValid) {
      submitBtn.classList.remove("loading");
      return;
    }

    try {
      const response = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "x-api-key": this.apiKey,
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        this.showToast("Form submitted successfully!", "success");
        this.form.reset();
      } else {
        this.showToast(data.message || "Submission failed", "error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      this.showToast("Something went wrong. Please try again.", "error");
    } finally {
      submitBtn.classList.remove("loading");
    }
  }

  showFieldError(fieldName, message) {
    const errorEl = document.getElementById(`error-${fieldName}`);
    if (errorEl) {
      errorEl.textContent = message;
    }
  }

  clearErrors() {
    this.form.querySelectorAll(".error-message").forEach((el) => {
      el.textContent = "";
    });
  }

  showToast(message, type) {
    this.toast.textContent = message;
    const closeBtn = document.createElement("button");
    closeBtn.innerHTML = "&times;";
    closeBtn.classList.add("close-btn");
    closeBtn.onclick = () => this.hideToast();
    this.toast.appendChild(closeBtn);

    this.toast.className = `form-toast show ${type}`;
    setTimeout(() => {
      closeBtn.click();
    }, 3000);
  }

  hideToast() {
    this.toast.className = "form-toast";
    this.toast.innerHTML = "";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new WarrantyForm("warrantyForm", "formToast");
});
